import { gql } from "@apollo/client";
import {
  IBenefitPaginated,
  IBenefit,
  BenefitCategory,
  BenefitNature,
  BenefitType,
} from "types/Benefit.type";

export interface IGetBenefitPaginationInput {
  page: number;
  pageSize: number;
  searchText?: string;
  countries?: string[];
  category?: BenefitCategory;
  nature?: BenefitNature;
  type?: BenefitType;
  isActive?: boolean;
  isFeatured?: boolean;
}

export interface IGetBenefitPaginationVariables {
  input: IGetBenefitPaginationInput;
}

export interface IBenefitPaginatedResponse {
  benefitsPaginated: IBenefitPaginated;
}

export interface IBenefitsResponse {
  benefits: IBenefit[];
}

export interface IBenefitCountriesSummaryResponse {
  benefitCountriesSummary: {
    countries: { code: string; total: number }[];
    transversalTotal: number;
  };
}

export const BENEFIT_COUNTRIES_SUMMARY = gql`
  query BenefitCountriesSummary {
    benefitCountriesSummary {
      countries {
        code
        total
      }
      transversalTotal
    }
  }
`;

export const GET_BENEFITS_PAGINATED = gql`
  query GetBenefitsPaginated($input: GetBenefitPaginationInput!) {
    benefitsPaginated(input: $input) {
      benefits {
        id
        name
        description
        type
        category
        nature
        countries
        detail
        externalUrl
        resources {
          id
          title
          url
          type
          fileName
          mimeType
        }
        otherTypeDescription
        hasValidity
        startDate
        endDate
        requiresApproval
        hasCapacityLimit
        capacityLimit
        requiresEvidence
        isActive
        isFeatured
        createdAt
        updatedAt
        imageUrl
      }
      total
    }
  }
`;

export const GET_BENEFITS = gql`
  query GetBenefits {
    benefits {
      id
      name
      description
      type
      category
      nature
      countries
      detail
      externalUrl
      resources {
        id
        title
        url
        type
        fileName
        mimeType
      }
      otherTypeDescription
      hasValidity
      startDate
      endDate
      requiresApproval
      requiresEvidence
      hasCapacityLimit
      capacityLimit
      isActive
      isFeatured
      createdAt
      updatedAt
      imageUrl
    }
  }
`;

export default {
  GET_BENEFITS_PAGINATED,
  GET_BENEFITS,
  BENEFIT_COUNTRIES_SUMMARY,
};
